import styled from "styled-components";
import { Flex } from "./Flex";
import { Label, Paragraph } from "./Text";
import { forwardRef } from "react";

const StyledLayout = styled.div`
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: ${({ direction}) => direction};
    overflow-y: hidden;
`;

const StyledSider = styled(Flex).attrs({
    direction: 'column',
    justify: 'space-between',
    height: "100%"
})`
    width: ${({collapsed}) => collapsed ? '80px' : '240px'};
    min-width: ${({collapsed}) => collapsed ? '80px' : '240px'};
    padding: 14px 0px 20px;
    background: var(--sp-text-color);
`;

const StyledScrollableMenuWrapper = styled.div`
    flex: 1;
    height: 100%;
    overflow: hidden;
`;

const StyledScrollableMenu = styled(Flex).attrs({
    direction: 'column',
    justify: 'space-between',
    height: "100%"
})`
    height: calc(100% + 17px);
    width: calc(100% + 17px);
    overflow: scroll;
`;

const StyledContent = styled(Flex).attrs(props => ({
    direction: "column",
    height: "calc(100vh - 64px)",
    width: "100%",
    background: props.background ? props.background : "#F0F4FB",
    padding: props.padding ? props.padding : { top: "24px", right: "40px", bottom: "33px", left: "42px" },
    gap: { bottom: 12 }
}))`
    min-width: 1200px;
    overflow-y: ${({scrollable}) => scrollable ? "scroll": undefined};
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(139, 164, 206, 0.4);
        border-radius: 10px;
        border: 1px solid transparent;
        background-clip: padding-box;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(139, 164, 206, 0.6);
      border: 1px solid transparent;
      background-clip: padding-box;
    }
`;

const StyledContentWrapper = styled(Flex)`
    flex: 1;
    height: 100%;
    padding-right: 8px;
    overflow: hidden;
`;


const StyledFrontPanel = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    padding: 0px 40px 24px 0px;

    transition: transform .6s ease-in-out;
    animation: toast-in-right .7s;
    z-index: 99;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

const Sider = (props) => <StyledSider {...props} />

const Content = forwardRef((props, ref) => (
    props.scrollable
        ? <StyledContentWrapper>
            <StyledContent {...props} ref={ref} />
        </StyledContentWrapper>
        : <StyledContent {...props} ref={ref} />
    ))

const Layout = (props) => <StyledLayout {...props} />

const ScrollableMenu = (props) => (
    <StyledScrollableMenuWrapper>
        <StyledScrollableMenu>
            {props.children}
        </StyledScrollableMenu>
    </StyledScrollableMenuWrapper>
);

const Front = (props) => <StyledFrontPanel {...props} />

export { Layout };
export { Sider };
export { Content };
export { Front };
export { ScrollableMenu };

export const renderFieldContent = (attributes, data, loading) => {
    return (Array.isArray(attributes)
        ? attributes.map((attribute, idx) => (
            attribute && (attribute.renderUndefined !== false || data[attribute.attr] !== undefined)
            ? <Flex key={`attribute-${idx}`} gap={{ right: 3 }} align="center">
                {attribute.label && <Paragraph color="var(--sp-label-color)" lineHeight="22px" whiteSpace="nowrap">{attribute.label}:</Paragraph>}
                <Paragraph nowrap={attribute.nowrap} isLoading={loading}>
                    {data && data.hasOwnProperty(attribute.attr) && data[attribute.attr] !== null && data[attribute.attr] !== undefined
                        ? attribute.render
                            ? attribute.render(data[attribute.attr], data)
                            : data[attribute.attr]
                        : attribute.label ? "-" : null
                    }
                </Paragraph>
            </Flex>
            : null
        ))
        : null)
};

export const parseDescription = (desc) => {
    return desc.split(/{red}/).map((para, i) => {
        para = para.replace(/\n$/, "");
        return para.split(/\n/).map((text, ii) =>
            i % 2 !== 0
                ? <Label key={`desc-part-${i}-${ii}`} style={{textTransform: "none", whiteSpace: "normal" }} size="14px" color="#FFF" filled fill="var(--sp-error-color)">{text}</Label>
                : <Paragraph key={`desc-part-${i}-${ii}`}>{text}</Paragraph>
    )})
};